var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.09 39.2V36.23C29.09 34.28 27.51 32.71 25.57 32.71H4.93002C2.98002 32.71 1.41003 34.29 1.41003 36.23V39.2H29.1H29.09Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.38 2.91001L6.66 19.57C5.39 21.11 5.60999 23.38 7.14999 24.65L15.82 31.79C17.36 33.06 19.63 32.84 20.9 31.3L25.73 25.43L41.31 38.26C42.67 39.38 44.68 39.19 45.8 37.83C46.92 36.47 46.73 34.46 45.37 33.34L29.79 20.51L34.62 14.64C35.89 13.1 35.67 10.83 34.13 9.56001L25.46 2.42001C23.92 1.15001 21.65 1.37001 20.38 2.91001Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 18.61C22.3071 18.61 23.01 17.9071 23.01 17.04C23.01 16.1729 22.3071 15.47 21.44 15.47C20.5729 15.47 19.87 16.1729 19.87 17.04C19.87 17.9071 20.5729 18.61 21.44 18.61Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerIcon);
export default __webpack_public_path__ + "static/media/answer-icon.48a291ff3c0722227d8b52d305d6a6df.svg";
export { ForwardRef as ReactComponent };